import { getLocation } from '@opengov/compose-app-router/selectors';
import { createSelector } from '@opengov/compose-app/reselect';
import { PATH_TEMPLATE } from '@opengov/stories-shared/constants';

export const selectIsTemplate: (state) => boolean = createSelector(getLocation, (location) => {
  const pathArray = location.pathname.split('/');
  const storyPath = pathArray[3]; // Find the path after entity
  return storyPath === PATH_TEMPLATE;
});

export const selectLastPath: (state) => string = createSelector(getLocation, (location) => {
  const pathArray = location.pathname.split('/');
  return pathArray[pathArray.length - 1];
});

export const selectPublicationLastPath: (state) => string = createSelector(getLocation, (location) => {
  const pathArray = location.pathname.split('/');
  return pathArray[pathArray.length - 1];
});
